import { motion } from "framer-motion";
import { Scissors, Slice, Flame, Droplets, Waves, ArrowUpRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { useSite } from "@/lib/site";
import { waLink } from "@/lib/api";

const ICONS = { scissors: Scissors, slice: Slice, flame: Flame, droplets: Droplets, waves: Waves };

export const Services = () => {
  const { t, L } = useI18n();
  const { data } = useSite();
  const s = data?.settings || {};
  const services = data?.services || [];

  return (
    <section id="servicios" data-testid="services-section" className="py-24 sm:py-32 relative">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <p className="font-mono text-[11px] tracking-[0.3em] text-gold mb-4">{t("services.eyebrow")}</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-bone leading-[0.95]">
              {t("services.title")}
            </h2>
          </div>
          <p className="max-w-sm text-mut text-sm sm:text-base md:text-right">{t("services.sub")}</p>
        </div>

        <div data-testid="services-list-container" className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((sv, i) => {
            const Icon = ICONS[sv.icon] || Scissors;
            return (
              <motion.div
                key={sv.id}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ delay: (i % 3) * 0.08, duration: 0.6 }}
                className="group relative border border-gold/10 bg-panel hover:border-gold/40 p-7 flex flex-col gap-5 transition-colors"
                data-testid={`service-card-${sv.id}`}
              >
                <div className="flex items-start justify-between">
                  <span className="font-mono text-xs text-gold/50">{String(i + 1).padStart(2, "0")}</span>
                  <Icon size={22} className="text-gold" />
                </div>
                <div>
                  <h3 className="font-display text-xl text-bone tracking-wide">{L(sv.name_es, sv.name_en)}</h3>
                  <p className="mt-2 text-sm text-mut leading-relaxed">{L(sv.desc_es, sv.desc_en)}</p>
                </div>
                <a
                  href={waLink(s.whatsapp)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`service-book-${sv.id}`}
                  className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-gold/70 group-hover:text-gold transition-colors"
                >
                  {t("services.book")}
                  <ArrowUpRight size={15} />
                </a>
              </motion.div>
            );
          })}

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ delay: (services.length % 3) * 0.08, duration: 0.6 }}
            className="relative bg-gold p-7 flex flex-col justify-between gap-5"
            data-testid="walkins-cta-card"
          >
            <Scissors size={22} className="text-ink" />
            <div>
              <h3 className="font-display text-2xl text-ink leading-tight">WALK-INS<br />WELCOME</h3>
              <p className="mt-2 text-sm text-ink/70 font-medium">Corte — Barba — Estilo</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Services;
